import {Component, Input, OnInit} from '@angular/core';
import {IHolidayDetailText} from '../../interfaces/iholiday-detail-text';

@Component({
  selector: 'app-detail-content-description',
  templateUrl: './detail-content-description.component.html',
  styleUrls: ['./detail-content-description.component.scss']
})
export class DetailContentDescriptionComponent implements OnInit {

  @Input() texts: IHolidayDetailText[];

  constructor() { }

  ngOnInit(): void {
    this.texts = this.texts.map(text => {
      text.description = text.description
      .replace(/Data Validità Da:\s*\d{4}-\d{2}-\d{2}<br\/?>/g, '')
      .replace(/Data Validità A:\s*\d{4}-\d{2}-\d{2}<br\/?>/g, '');
      return text;
    });
  }
}
